module.exports = __webpack_public_path__ + "img/right.24681236.svg";